export default __webpack_public_path__ + "static/media/plus.1e6479a0.svg";